export function auditLabel(action: string): string {
  if (action === "document.create") return "PDF importé et empreinte prise";
  if (action === "document.update") return "Cases enregistrées";
  if (action === "document.send") return "Envoyé à la première partie — pièce figée";
  if (action === "document.resend") return "Mail renvoyé";
  if (action === "document.otp") return "Code d’accès envoyé";
  if (action === "document.piece") return "Pièce déposée";
  if (action === "document.next_fail") return "Invitation suivante en échec";
  if (action === "document.link") return "Lien portail régénéré";
  if (action === "document.cgu") return "Conditions d’utilisation acceptées";
  if (action === "document.consent") return "Consentement explicite";
  if (action === "document.sign") return "Signature électronique";
  if (action === "document.otp_exempt") return "Circuit interne sans code";
  if (action === "document.view") return "Première consultation portail";
  if (action === "document.revisit") return "Nouvelle consultation portail";
  if (action === "document.archive") return "Archivé";
  if (action === "document.restore") return "Restauré";
  if (action === "document.move") return "Déplacé";
  if (action === "document.clone") return "Cloné";
  if (action === "document.delete") return "Supprimé";
  if (action === "party.create") return "Partie ajoutée";
  if (action === "party.update") return "Partie mise à jour";
  if (action === "party.delete") return "Partie retirée";
  return action;
}

export function cleanDetail(detail: string): string {
  return detail.replace(/\s*[a-f0-9]{64}\s*/gi, " ").replace(/\s+/g, " ").trim();
}
